import Vue from 'vue';
import _get from 'lodash/get';
const WHITE_LIST = [
  'rgba[3]',
  'postMessage',
  'null is not an object (evaluating \'t.indexOf\')',
  // vue-frag
  'Cannot read property \'apply\' of undefined',
  'window.AEJSBridge.dispatch',
  'c35 is not defined',
  'Non-Error exception captured',
  'Non-Error promise rejection captured',
  // 忽略微信开放标签问题
  // eslint-disable-next-line quotes
  "Cannot use 'in' operator to search for '#<CustomEvent>",
  'webViewReady',
  // 过滤掉灯塔sdk问题，非
  'removeSendingId',
  'TypeError: Cannot read property \'mapValue\' of undefined',
  // https://github.com/getsentry/sentry-javascript/issues/3040
  'window.webkit.messageHandlers',
  'Connection to Indexed Database server lost',
  // 源码中没有怀疑是插件的操作
  'runCustomize',
  'window.bannerNight',
];
const initalize = () => {
  // 运行时区分环境
  // 测试环境的是：ares.nb.qq.com/test/xxx.html
  // 泳道生成的是：ares.nb.qq.com/test/分支名/xxx.html
  // 正式环境的是: ares.nb.qq.com/dist/xxx.html
  if (location.pathname.startsWith('/test/'))  {
    return false;
  }
  if (!process.env.SENTRY_DSN) {
    return false;
  }


  const Sentry = require('@sentry/browser');
  const Integrations = require('@sentry/integrations');

  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    release: `${process.env.SENTRY_RELEASE}`,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
    beforeSend(event) {
      const values = _get(event, 'exception.values') || [];
      // 遇到三方npm、插件错误
      // 不上报
      const cancelSend = values.some((item) => {
        const { type = '', value = '' } = item || {};
        const isHitWhiteList = WHITE_LIST.some(error => type.indexOf(error) > -1 || value.indexOf(error) > -1);
        if (isHitWhiteList) {
          return true;
        }
        return false;
      });


      return cancelSend ? null : event;
    },
  });
};

export default {
  initalize,
};
